export default {
  ROOT: '/',
  LOGIN: '/login',
  PROJECTS: '/projects',
  PROJECT: '/project/:id',
  CONTACT: '/contact',
};
